// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1BkjDTm7ZAxuNjPO254MRK"};